import MicroModal from 'micromodal';

export const drawerConfig = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.querySelector('.js-drawerOverlay');
    const inner = document.querySelector('.js-drawerInner');

    MicroModal.init({
      onShow: () => {
        overlay.classList.add('is-show');
        inner.classList.add('is-open');
      },
      onClose: () => {
        overlay.classList.remove('is-show');
        inner.classList.remove('is-open');
      },
      disableScroll: true,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  });
};
